<script>
  import tipoUsuario from '~js/tipo-usuario';
  import menuServico from '~js/menu-servico';
  import { computedsDeAcesso } from '~js/acessos';

  import Vue from 'vue';
  import VueResource from 'vue-resource';

  Vue.use(VueResource);

  export default {
    data() {
      return {
        usuario: this.$storage.usuario(),
        configuracao: this.$storage.configuracao(),
        termoLGPD: this.$storage.termoLGPD(),
        termoFornecedor: this.$storage.termoFornecedor(),
        tipoUsuario: tipoUsuario,
        urlImagem: true,
      }
    },
    methods: {
      setaItemCompra(tipo) {
        this.$storage.tipoItemCompra(tipo);
      },
      mostrarAvisoLGPD() {
        if (!this.configuracao.lgpdAvisoGeral) return;
        if (!this.usuario || this.usuario.tipoUsuario !== tipoUsuario.Coordenador) return;

        if (!this.termoLGPD) {
          this.$swal({
            title: 'Lei Geral de Proteção de Dados (LGPD)',
            html: '<br><br>' + this.configuracao.lgpdAvisoGeral.replace(/\r\n/g, '<br>') + '<br><br>',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Aceito!',
            cancelButtonText: "Não aceito!",
            allowOutsideClick: false,
            allowEscapeKey: false,
          })
            .then((result) => {
              if (result) {
                menuServico.termoLGPD(this.usuario, true)
                  .then(resposta => {
                    this.$storage.termoLGPD(true);
                  })
                  .catch(error => {
                    this.$swal('', 'Ocorreu um erro ao aprovar o termo da LGPD.', 'error');
                  });
              }
            })
            .catch((error) => {
              menuServico.termoLGPD(this.usuario, false)
                .then(resposta => {
                  this.$storage.termoLGPD(false);
                  this.$events.$emit('logout')
                })
                .catch(erro => {
                  this.$swal('', 'Ocorreu um erro ao reprovar o termo da LGPD.', 'error');
                });
            });
        }
      },
      mostrarAvisoFornecedor() {
        if (!this.configuracao.fornecedorAvisoGeral) return;
        if (!this.usuario
          || (this.usuario.tipoUsuario !== tipoUsuario.Fornecedor
            && this.usuario.tipoUsuario !== tipoUsuario.FornecedorWeb
            && this.usuario.tipoUsuario !== tipoUsuario.FornecedorWebNovo)) return;

        if (!this.termoFornecedor) {
          this.$swal({
            title: 'Termo de Utilização de Informações do Fornecedor',
            html: '<br><br>' + this.configuracao.fornecedorAvisoGeral.replace(/\r\n/g, '<br>') + '<br><br>',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Aceito!',
            cancelButtonText: "Não aceito!",
            allowOutsideClick: false,
            allowEscapeKey: false,
          })
            .then((result) => {
              if (result) {
                menuServico.termoFornecedor(this.usuario, true)
                  .then(resposta => {
                    this.$storage.termoFornecedor(true);
                  })
                  .catch(error => {
                    this.$swal('', 'Ocorreu um erro ao aprovar o termo do fornecedor.', 'error');
                  });
              }
            })
            .catch((error) => {
              menuServico.termoFornecedor(this.usuario, false)
                .then(resposta => {
                  this.$storage.termoFornecedor(false);
                  this.$events.$emit('logout')
                })
                .catch(erro => {
                  this.$swal('', 'Ocorreu um erro ao reprovar o termo do fornecedor.', 'error');
                });
            });
        }
      },
      verificarUrlImagem() {

        Vue.http.get('/img/logo.png')
          .then(() => {

            this.urlImagem = true;
          }).catch(() => {

            this.urlImagem = false;
          });
      },
    },
    mounted() {
      this.$nextTick(function () {
        // MetsiMenu
        $('#side-menu').metisMenu();
      });
      if (!this.termoLGPD) {
        this.mostrarAvisoLGPD();
      }
      if (!this.termoFornecedor) {
        this.mostrarAvisoFornecedor();
      }
      this.verificarUrlImagem();
    },
    beforeUpdated() {
      if (!this.termoLGPD) {
        this.mostrarAvisoLGPD();
      }
      if (!this.termoFornecedor) {
        this.mostrarAvisoFornecedor();
      }
    },
    computed: {
      ...computedsDeAcesso(),
    }
  }
</script>

<template>
  <nav class="navbar-default navbar-static-side" role="navigation">
    <div class="sidebar-collapse">
      <ul class="nav metismenu" id="side-menu">
        <li class="nav-header">
          <div class="dropdown profile-element">
            <span v-show="urlImagem">
              <img alt="image empresa" class="img-responsive" src="img/logo.png">
            </span>
            <span v-show="!urlImagem">
              <img alt="image gemini" class="img-responsive" src="img/logo-gemini.png">
            </span>
            <a data-toggle="dropdown" class="dropdown-toggle" href="#" v-if="(usuario.tipoUsuario !== tipoUsuario.FornecedorWebNovo)">
              <span class="clear">
                <span class="block m-t-xs">
                  <strong class="font-bold">{{ usuario.nome }}</strong>
                </span> <span class="text-muted text-xs block">Opções <b class="caret"></b></span>
              </span>
            </a>
            <ul class="dropdown-menu animated flipInX m-t-xs">
              <router-link tag="li" :to="{ name: 'alterar-senha' }" active-class="" exact-active-class=""
                           v-if="(usuario.tipoUsuario !== tipoUsuario.Aluno) && (usuario.tipoUsuario !== tipoUsuario.Funcionario) && (usuario.tipoUsuario !== tipoUsuario.AcessoEspecial)
                           && (usuario.tipoUsuario !== tipoUsuario.FornecedorWebNovo)">
                <a>
                  <i class="fa fa-key"></i>
                  Alterar senha
                </a>
              </router-link>
              <router-link tag="li" :to="{ name: 'alterar-email' }" active-class="" exact-active-class=""
                           v-if="(usuario.tipoUsuario !== tipoUsuario.Aluno) && (usuario.tipoUsuario !== tipoUsuario.Funcionario) && (usuario.tipoUsuario !== tipoUsuario.AcessoEspecial)
                           && (usuario.tipoUsuario !== tipoUsuario.Fornecedor) && (usuario.tipoUsuario !== tipoUsuario.FornecedorWeb) && (usuario.tipoUsuario !== tipoUsuario.FornecedorWebNovo)
                           && (usuario.tipoUsuario !== tipoUsuario.FornecedorWeb)">
                <a>
                  <i class="fa fa-envelope-o"></i>
                  Alterar e-mail
                </a>
              </router-link>
              <li class="divider" v-if="(usuario.tipoUsuario !== tipoUsuario.Aluno) && (usuario.tipoUsuario !== tipoUsuario.Funcionario) && (usuario.tipoUsuario !== tipoUsuario.AcessoEspecial)">></li>
              <li><a @click.prevent="$events.$emit('logout')">Sair</a></li>
            </ul>
          </div>
          <div class="logo-element">
            {{ configuracao.abreviaturaFundacao }}
          </div>
        </li>

        <router-link tag="li" :to="{ name: 'home' }" exact="">
          <a>
            <i class="fa fa-th-large"></i>
            <span class="nav-label">{{ usuario.tipoUsuario === tipoUsuario.Aluno ? 'Cursos' : 'Página Inicial' }}</span>
          </a>
        </router-link>

        <li style="border-bottom: 1px solid;"></li>

        <router-link tag="li" :to="{ name: 'liberar-solicitacoes' }" v-if="liberarSolicitacoes">
          <a>
            <i class="fa fa-check"></i>
            <span class="nav-label">Liberar Solicitações</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'mensagem' }" v-if="mensagemSistema">
          <a>
            <i class="fa fa-comments"></i>
            <span class="nav-label">Mensagens Sistema</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'termino-projetos' }" v-if="terminoProjeto">
          <a>
            <i class="fa fa-list-alt"></i>
            <span class="nav-label">Projetos Terminando</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'notificacoes' }" v-if="liberarSolicitacoes || mensagemSistema || liberarPedidosCompra || aprovarPesquisaPreco || solReembolsoAtividade || liberarPagamento || liberarProvisoesPagamento">
          <a>
            <i class="fa fa-bell-o"></i>
            <span class="nav-label">Notificações</span>
          </a>
        </router-link>

        <li style="border-bottom: 1px solid;"></li>

        <router-link tag="li" :to="{ name: 'acompanhamento-projeto' }" v-if="acompanhamentoProjeto">
          <a>
            <i class="fa fa-handshake-o"></i>
            <span class="nav-label">Acompanhamento Projeto</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'importacao-projeto' }" v-if="solImportacaoProjetos">
          <a>
            <i class="fa fa-ship"></i>
            <span class="nav-label">Acompanhar Importações</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'relatorio-tecnico-projeto' }" v-if="relatorioTecnicoProjeto">
          <a>
            <i class="fa fa-handshake-o"></i>
            <span class="nav-label">Relatório Técnico Projeto</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'aprovar-pesquisa-preco' }" v-if="aprovarPesquisaPreco">
          <a>
            <i class="fa fa-list-alt"></i>
            <span class="nav-label">Aprovar Pesquisa Preço</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'aprovar-passagem' }" v-if="aprovarPesquisaPreco">
          <a>
            <i class="fa fa-plane"></i>
            <span class="nav-label">Aprovar Passagem</span>
          </a>
        </router-link>

        <router-link tag="li"
                     :to="{ name: 'solicitacao-bolsa-atividades' }"
                     v-if="solBolsaAtividade">
          <a>
            <i class="fa fa-list-alt"></i>
            <span class="nav-label">{{ configuracao.nomeModuloSolContratos.replace('?', 'á') + ' - Atividades'}}</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'contrato.liberados' }" v-if="utilizarLiberacaoContrato">
          <a>
            <i class="fa fa-address-card"></i>
            <span class="nav-label">Contratos</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'solicitacao-doacao-realizadas' }" v-if="doacoesRealizadas">
          <a>
            <i class="fa fa-handshake-o"></i>
            <span class="nav-label">Doações realizadas</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'solicitacao-evento-realizados' }" v-if="eventosRealizados">
          <a>
            <i class="fa fa-calendar"></i>
            <span class="nav-label">Eventos realizados</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'projeto' }" v-if="infoProjeto">
          <a>
            <i class="fa fa-book"></i>
            <span class="nav-label">Informações do Projeto</span>
          </a>
        </router-link>

        <li :class="{'active': $route.name.startsWith('compra')}" v-if="usuarioLiberarCompras">
          <a href="#">
            <i class="fa fa-address-card"></i>
            <span class="nav-label">Liberação Compras</span><span class="fa arrow"></span>
          </a>
          <ul class="nav nav-second-level" :class="{'in': $route.name.startsWith('compra')}">

            <router-link tag="li"
                         :to="{ name: 'compra.compra' }"
                         v-if="usuarioLiberarCompras">
              <a>
                <i class="fa fa-shopping-basket"></i>
                <span class="nav-label">Compras</span>
              </a>
            </router-link>

            <router-link tag="li"
                         :to="{ name: 'compra.importacao' }"
                         v-if="usuarioLiberarCompras">
              <a>
                <i class="fa fa-ship"></i>
                <span class="nav-label">Importação</span>
              </a>
            </router-link>

          </ul>
        </li>

        <li :class="{'active': $route.name.startsWith('contrato')}" v-if="usuarioLiberarContratos">
          <a href="#">
            <i class="fa fa-address-card"></i>
            <span class="nav-label">Liberação Contratos</span><span class="fa arrow"></span>
          </a>
          <ul class="nav nav-second-level" :class="{'in': $route.name.startsWith('contrato')}">

            <router-link tag="li"
                         :to="{ name: 'contrato', params: { tipo : 1 } }"
                         v-if="usuarioLiberarContratos">
              <a>
                <i class="fa fa-address-card"></i>
                <span class="nav-label">Bolsa</span>
              </a>
            </router-link>

            <router-link tag="li"
                         :to="{ name: 'contrato', params: { tipo : 0 } }"
                         v-if="usuarioLiberarContratos">
              <a>
                <i class="fa fa-address-card"></i>
                <span class="nav-label">Outros</span>
              </a>
            </router-link>

          </ul>
        </li>

        <router-link tag="li" :to="{ name: 'liberar-pedidos-compra' }" v-if="liberarPedidosCompra">
          <a>
            <i class="fa fa-shopping-cart"></i>
            <span class="nav-label">Liberar Pedidos de Compra</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'liberar-provisoes-pagamento' }" v-if="liberarProvisoesPagamento">
          <a>
            <i class="fa fa-money"></i>
            <span class="nav-label">Liberar Provisões</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'liberar-pagamento' }" v-if="liberarPagamento">
          <a>
            <i class="fa fa-check-square-o"></i>
            <span class="nav-label">Liberar Pagamento</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'solicitacao-curso-evento-matricular' }" v-if="matricularAlunos">
          <a>
            <i class="fa fa-user-plus"></i>
            <span class="nav-label">Inscrições Alunos</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'pedido' }" v-if="pedidoCompra">
          <a>
            <i class="fa fa-truck"></i>
            <span class="nav-label">Pedidos de Compra</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'solicitacao-importacao' }" v-if="solImportacao && false">
          <a><i class="fa fa-shopping-cart"></i><span class="nav-label">Solicitação de Importação</span></a>
        </router-link>

        <router-link tag="li" :to="{ name: 'importacao.principal' }" v-if="solImportacao">
          <a><i class="fa fa-ship"></i><span class="nav-label">Importações</span></a>
        </router-link>

        <router-link tag="li" :to="{ name: 'solicitacao-reembolso-pf-atividade' }" v-if="solReembolsoAtividade">
          <a>
            <i class="fa fa-plane"></i>
            <span class="nav-label">Diária {{ configuracao.utilizarSolicitacaoAdiantamentoPassagemWeb ? ' - Passagem' : '' }} {{ configuracao.utilizarSolicitacaoAdiantamentoWeb ? ' - Adiantamento' : '' }} - Prestação de contas</span>
          </a>
        </router-link>

        <li :class="{'active': $route.name.startsWith('solicitacao.')}" v-if="solicitacoes">
          <a href="#">
            <i class="fa fa-handshake-o"></i>
            <span class="nav-label">Solicitações</span><span class="fa arrow"></span>
          </a>
          <ul class="nav nav-second-level collapse" :class="{'in': $route.name.startsWith('solicitacao.')}">

            <router-link tag="li" :to="{ name: 'solicitacao-adiantamento' }" v-if="solAdiantamento">
              <a><i class="fa fa-money"></i><span class="nav-label">Adiantamento</span></a>
            </router-link>

            <router-link tag="li" :to="{ name: 'solicitacao-bolsa' }" v-if="solBolsa">
              <a><i class="fa fa-address-card"></i><span class="nav-label">{{ configuracao.nomeModuloSolContratos.replace('?', 'á') }}</span></a>
            </router-link>

            <router-link tag="li" :to="{ name: 'solicitacao-cancelamento-contrato' }" v-if="solCancelamentoContrato">
              <a><i class="fa fa-address-card-o"></i><span class="nav-label">Cancelamento Contrato</span></a>
            </router-link>

            <router-link tag="li" :to="{ name: 'solicitacao-contratacao-pessoal' }" v-if="solContratacaoPessoal">
              <a><i class="fa fa-users"></i><span class="nav-label">Contratação Pessoal</span></a>
            </router-link>

            <router-link tag="li" :to="{ name: 'solicitacao-compra' }" v-if="solCompras && !fusp">
              <a><i class="fa fa-shopping-basket"></i><span class="nav-label">Compra</span></a>
            </router-link>

            <li :class="{'active': (/^solicitacao-compra/.test($route.name))}" v-if="(solCompras || solImportacaoProjetos) && fusp">
              <a href="#"><i class="fa fa-shopping-basket"></i><span class="nav-label">Compra</span><span class="fa arrow"></span></a>
              <ul class="nav nav-third-level collapse"
                  :class="{'in': (/^solicitacao-compra/.test($route.name))}">
                <router-link tag="li" :to="{ name: 'solicitacao-compra' }" v-if="solCompras" @click.native="setaItemCompra(1)">
                  <a>Nacional</a>
                </router-link>
                <router-link tag="li" :to="{ name: 'solicitacao-importacao-projeto' }" v-if="solImportacaoProjetos">
                  <a>Internacional</a>
                </router-link>
                <router-link tag="li" :to="{ name: 'solicitacao-compra' }" v-if="solCompras" @click.native="setaItemCompra(2)">
                  <a>Online</a>
                </router-link>
              </ul>
            </li>

            <router-link tag="li" :to="{ name: 'solicitacao-curso-evento-servico' }" v-if="solCursoEventoServico">
              <a><i class="fa fa-graduation-cap"></i><span class="nav-label">{{ configuracao.nomeModuloSolCursoEventoServico }}</span></a>
            </router-link>

            <li :class="{'active': (/^solicitacao-reembolso-(nacional|estrangeiro)/.test($route.name))}" v-if="solReembolso">
              <a href="#"><i class="fa fa-plane"></i><span class="nav-label">Diária {{ configuracao.utilizarSolicitacaoAdiantamentoPassagemWeb ? ' - Passagem' : '' }} {{ configuracao.utilizarSolicitacaoAdiantamentoWeb ? ' - Adiantamento' : '' }}</span><span class="fa arrow"></span></a>
              <ul class="nav nav-third-level collapse"
                  :class="{'in': (/^solicitacao-reembolso-(nacional|estrangeiro)/.test($route.name))}"
                  v-if="usuario.tipoUsuario === tipoUsuario.Coordenador">
                <router-link tag="li" :to="{ name: 'solicitacao-reembolso-pf' }" v-if="solReembolso">
                  <a>Pessoa Física</a>
                </router-link>
                <router-link tag="li" :to="{ name: 'solicitacao-reembolso-estrangeiro' }" v-if="solReembolsoEstrangeiro">
                  <a>Estrangeiro</a>
                </router-link>
              </ul>
            </li>

            <li :class="{'active': (/^solicitacao-faturamento-(pfpj|estrangeiropf|estrangeiropj)/.test($route.name))}" v-if="solFaturamento">
              <a href="#"><i class="fa fa-calculator"></i><span class="nav-label">Faturamento</span><span class="fa arrow"></span></a>
              <ul class="nav nav-third-level collapse"
                  :class="{'in': (/^solicitacao-faturamento-(pfpj|estrangeiropf|estrangeiropj)/.test($route.name))}"
                  v-if="usuario.tipoUsuario === tipoUsuario.Coordenador">
                <router-link tag="li" :to="{ name: 'solicitacao-faturamento-pfpj' }" v-if="solFaturamentoPFPJ">
                  <a>Pessoa Física e Jurídica</a>
                </router-link>
                <router-link tag="li" :to="{ name: 'solicitacao-faturamento-multiservicos' }" v-if="solFaturamentoMC">
                  <a>Multiserviços</a>
                </router-link>
                <router-link tag="li" :to="{ name: 'solicitacao-faturamento-estrangeiro-pf' }" v-if="solFaturamentoEstrangeiroPF">
                  <a>Estrangeiro PF</a>
                </router-link>
                <router-link tag="li" :to="{ name: 'solicitacao-faturamento-estrangeiro-pj' }" v-if="solFaturamentoEstrangeiroPJ">
                  <a>Estrangeiro PJ</a>
                </router-link>
              </ul>
            </li>

            <router-link tag="li" :to="{ name: 'solicitacao-importacao-projeto' }" v-if="solImportacaoProjetos">
              <a><i class="fa fa-ship"></i><span class="nav-label">Importação</span></a>
            </router-link>

            <li :class="{'active': (/^solicitacao-pagamento-(pf|pj|estrangeiropf|estrangeiropj)/.test($route.name))}" v-if="solPagamento">
              <a href="#"><i class="fa fa-money"></i><span class="nav-label">Pagamento </span><span class="fa arrow"></span></a>
              <ul class="nav nav-third-level collapse"
                  :class="{'in': (/^solicitacao-pagamento-(pf|pj|estrangeiropf|estrangeiropj)/.test($route.name))}"
                  v-if="usuario.tipoUsuario === tipoUsuario.Coordenador">
                <router-link tag="li" :to="{ name: rotaSolicitacaoPF }" v-if="solPagamentoPessoaFisica">
                  <a>Pessoa Física</a>
                </router-link>
                <router-link tag="li" :to="{ name: rotaSolicitacaoPJ }" v-if="solPagamentoPessoaJuridica">
                  <a>Pessoa Jurídica</a>
                </router-link>
                <router-link tag="li" :to="{ name: rotaSolicitacaoEstrangeiroPF }" v-if="solPagamentoEstrangeiroPF">
                  <a>Estrangeiro PF</a>
                </router-link>
                <router-link tag="li" :to="{ name: rotaSolicitacaoEstrangeiroPJ }" v-if="solPagamentoEstrangeiroPJ">
                  <a>Estrangeiro PJ</a>
                </router-link>
              </ul>
            </li>

            <li :class="{'active': (/^solicitacao-pagamento-rateio-(pf|pj)/.test($route.name))}" v-if="solPagamentoRateio">
              <a href="#"><i class="fa fa-money"></i><span class="nav-label">Pagamento - Rateio</span><span class="fa arrow"></span></a>
              <ul class="nav nav-third-level collapse"
                  :class="{'in': (/^solicitacao-pagamento-rateio-(pf|pj)/.test($route.name))}"
                  v-if="usuario.tipoUsuario === tipoUsuario.Coordenador">
                <router-link tag="li" :to="{ name: rotaSolicitacaoPFRateio }" v-if="solPagamentoPessoaFisicaRateio">
                  <a>Pessoa Física</a>
                </router-link>
                <router-link tag="li" :to="{ name: rotaSolicitacaoPJRateio }" v-if="solPagamentoPessoaJuridicaRateio">
                  <a>Pessoa Jurídica</a>
                </router-link>
              </ul>
            </li>

            <router-link tag="li" :to="{ name: 'solicitacao-reembolso-terceiro' }" v-if="solReembolsoTerceiro">
              <a><i class="fa fa-money"></i><span class="nav-label">Reembolso Terceiro</span></a>
            </router-link>

            <router-link tag="li" :to="{ name: 'solicitacao-transferencia' }" v-if="solTransferencia">
              <a><i class="fa fa-refresh"></i><span class="nav-label">Transferência</span></a>
            </router-link>

          </ul>
        </li>

        <!--RELATÓRIOS COORDENADOR-->
        <li :class="{'active': $route.name.startsWith('relatorio.')}"
            v-if="relatorios">
          <a href="#">
            <i class="fa fa-line-chart"></i>
            <span class="nav-label">Relatórios </span><span class="fa arrow"></span>
          </a>
          <ul class="nav nav-second-level collapse"
              :class="{'in': $route.name.startsWith('relatorio.')}">
            <router-link tag="li" :to="{ name: 'relatorio.aplicacoes-financeiras' }" v-if="relLancamentoAplicacao">
              <a>Aplicações Financeira</a>
            </router-link>
            <router-link tag="li" :to="{ name: 'relatorio.contas-pagar-receber' }" v-if="relContasPagarReceber">
              <a>Contas a Pagar e Receber</a>
            </router-link>
            <router-link tag="li" :to="{ name: 'relatorio.controle-item' }" v-if="relControleItem">
              <a>Controle Item</a>
            </router-link>
            <router-link tag="li" :to="{ name: 'relatorio.impostos' }" v-if="relImpostosPorProjeto">
              <a>Impostos</a>
            </router-link>
            <router-link tag="li" :to="{ name: rotaRelatorioFinanceiro }" v-if="relLancamentoFinanceiro">
              <a>Lançamentos Financeiros</a>
            </router-link>
            <router-link tag="li" :to="{ name: 'relatorio.lancamentos-resumo' }" v-if="relLancamentoFinanceiroResumo">
              <a>Lançamentos Financeiros Resumo</a>
            </router-link>
            <router-link tag="li" :to="{ name: 'relatorio.lancamentos-projetos' }" v-if="relLancamentoFinanceiroProjeto">
              <a>Lançamentos Financeiros Projetos</a>
            </router-link>
            <router-link tag="li" :to="{ name: 'relatorio.lancamentos-cambio' }" v-if="relLancamentoCambio">
              <a>Lançamentos Financeiros/Câmbio</a>
            </router-link>
            <router-link tag="li" :to="{ name: 'relatorio.mensalidades-agrupadas-por-aluno' }" v-if="relMensalidadeAluno">
              <a>Mensalidades Agrupadas por Aluno</a>
            </router-link>
            <router-link tag="li" :to="{ name: 'relatorio.pedidos-compra' }" v-if="relPedidoCompra">
              <a>Pedidos de Compra</a>
            </router-link>
            <router-link tag="li" :to="{ name: 'relatorio.protocolos' }" v-if="relProtocolos">
              <a>Protocolos</a>
            </router-link>
            <router-link tag="li" :to="{ name: 'relatorio.provisoes' }" v-if="relProvisoes">
              <a>Provisões</a>
            </router-link>
            <router-link tag="li" :to="{ name: 'relatorio.rubricas' }" v-if="relRubrica">
              <a>Rubricas</a>
            </router-link>
            <router-link tag="li" :to="{ name: 'relatorio.saldos' }" v-if="relSaldos">
              <a>Saldos</a>
            </router-link>
            <router-link tag="li" :to="{ name: 'relatorio.subrubricas' }" v-if="relSubrubrica">
              <a>Subrubricas</a>
            </router-link>
            <router-link tag="li" :to="{ name: 'relatorio.taxasProjeto' }" v-if="relProvisoes && fusp">
              <a>Taxas projeto</a>
            </router-link>
            <router-link tag="li" :to="{ name: 'relatorio.verificacao-de-pagamentos' }" v-if="relVerificacaoLancamento">
              <a>Verificação de Pagamentos</a>
            </router-link>
          </ul>
        </li>

        <!--RELATÓRIOS FUNCIONÁRIOS-->
        <li :class="{'active': $route.name.startsWith('relatorio.')}"
            v-if="relatoriosFuncionario">
          <a href="#">
            <i class="fa fa-line-chart"></i>
            <span class="nav-label">Relatórios </span><span class="fa arrow"></span>
          </a>
          <ul class="nav nav-second-level collapse"
              :class="{'in': $route.name.startsWith('relatorio.')}">
            <router-link tag="li" :to="{ name: 'relatorio.aplicacoes-financeiras' }" v-if="relLancamentoAplicacaoFuncionario">
              <a>Aplicações Financeira</a>
            </router-link>
            <router-link tag="li" :to="{ name: 'relatorio.contas-pagar-receber' }" v-if="relContasPagarReceberFuncionario">
              <a>Contas a Pagar e Receber</a>
            </router-link>
            <!--<router-link tag="li" :to="{ name: 'relatorio.controle-item' }" v-if="relControleItem">
        <a>Controle Item</a>
      </router-link>-->
            <!--<router-link tag="li" :to="{ name: 'relatorio.impostos' }" v-if="relImpostosPorProjeto">
        <a>Impostos</a>
      </router-link>-->
            <router-link tag="li" :to="{ name: rotaRelatorioFinanceiro }" v-if="relLancamentoFinanceiroFuncionario">
              <a>Lançamentos Financeiros</a>
            </router-link>
            <!--<router-link tag="li" :to="{ name: 'relatorio.lancamentos-resumo' }" v-if="relLancamentoFinanceiroResumo">
        <a>Lançamentos Financeiros Resumo</a>
      </router-link>-->
            <!--<router-link tag="li" :to="{ name: 'relatorio.lancamentos-projetos' }" v-if="relLancamentoFinanceiroProjeto">
        <a>Lançamentos Financeiros Projetos</a>
      </router-link>-->
            <!--<router-link tag="li" :to="{ name: 'relatorio.lancamentos-cambio' }" v-if="relLancamentoCambio">
        <a>Lançamentos Financeiros/Câmbio</a>
      </router-link>-->
            <!--<router-link tag="li" :to="{ name: 'relatorio.mensalidades-agrupadas-por-aluno' }" v-if="relMensalidadeAluno">
        <a>Mensalidades Agrupadas por Aluno</a>
      </router-link>-->
            <!--<router-link tag="li" :to="{ name: 'relatorio.pedidos-compra' }" v-if="relPedidoCompra">
        <a>Pedidos de Compra</a>
      </router-link>-->
            <router-link tag="li" :to="{ name: 'relatorio.protocolos' }" v-if="relProtocolosFuncionario">
              <a>Protocolos</a>
            </router-link>
            <!--<router-link tag="li" :to="{ name: 'relatorio.provisoes' }" v-if="relProvisoes">
        <a>Provisões</a>
      </router-link>-->
            <router-link tag="li" :to="{ name: 'relatorio.rubricas' }" v-if="relRubricaFuncionario">
              <a>Rubricas</a>
            </router-link>
            <!--<router-link tag="li" :to="{ name: 'relatorio.saldos' }" v-if="relSaldos">
        <a>Saldos</a>
      </router-link>-->
            <router-link tag="li" :to="{ name: 'relatorio.subrubricas' }" v-if="relSubrubricaFuncionario">
              <a>Subrubricas</a>
            </router-link>
            <!--<router-link tag="li" :to="{ name: 'relatorio.taxasProjeto' }" v-if="relProvisoes && fusp">
        <a>Taxas projeto</a>
      </router-link>-->
            <!--<router-link tag="li" :to="{ name: 'relatorio.verificacao-de-pagamentos' }" v-if="relVerificacaoLancamento">
        <a>Verificação de Pagamentos</a>
      </router-link>-->
          </ul>
        </li>

        <!--Acesso Fornecedor-->
        <router-link tag="li" :to="{ name: 'fornecedor.alterar' }" v-if="(usuario.tipoUsuario === tipoUsuario.Fornecedor)">
          <a>
            <i class="fa fa-edit"></i>
            <span class="nav-label">Alterar cadastro</span>
          </a>
        </router-link>
        <router-link tag="li" :to="{ name: 'web-fornecedor.alterar' }" v-if="(usuario.tipoUsuario === tipoUsuario.FornecedorWeb
                     || usuario.tipoUsuario === tipoUsuario.FornecedorWebNovo)">
          <a>
            <i class="fa fa-edit"></i>
            <span class="nav-label">Alterar Cadastro</span>
          </a>
        </router-link>
        <router-link tag="li" :to="{ name: 'fornecedor.contrato' }" v-if="usuario.tipoUsuario === tipoUsuario.Fornecedor">
          <a>
            <i class="fa fa-folder"></i>
            <span class="nav-label">Contratos</span>
          </a>
        </router-link>
        <router-link tag="li" :to="{ name: 'fornecedor.solicitacao-pesquisa-preco' }"
                     v-if="usuario.tipoUsuario === tipoUsuario.Fornecedor && usuario.informarPesquisaWEB">
          <a>
            <i class="fa fa-usd"></i>
            <span class="nav-label">Pesquisa de Preço</span>
          </a>
        </router-link>
        <li v-if="usuario.tipoUsuario === tipoUsuario.Fornecedor">
          <a href="#">
            <i class="fa fa-line-chart"></i>
            <span class="nav-label">Relatórios </span><span class="fa arrow"></span>
          </a>
          <ul class="nav nav-second-level collapse">
            <router-link tag="li" :to="{ name: 'relatorio.verificacao-de-pagamentos-fornecedor' }" v-if="usuario.tipoUsuario === tipoUsuario.Fornecedor">
              <a>Verificação de Pagamentos</a>
            </router-link>
          </ul>
        </li>

        <!--Acesso Pessoa Física-->
        <router-link tag="li" :to="{ name: 'pessoa-fisica.alterar' }" v-if="(usuario.tipoUsuario === tipoUsuario.PessoaFisica)">
          <a>
            <i class="fa fa-edit"></i>
            <span class="nav-label">Alterar Cadastro</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'pessoa-fisica.mensalidades' }" v-if="(usuario.tipoUsuario === tipoUsuario.PessoaFisica)">
          <a>
            <i class="fa fa-graduation-cap"></i>
            <span class="nav-label">Mensalidades</span>
          </a>
        </router-link>
        <router-link tag="li" :to="{ name: 'web-pessoa-fisica.alterar' }" v-if="(usuario.tipoUsuario === tipoUsuario.PessoaFisicaWeb
                     || usuario.tipoUsuario === tipoUsuario.PessoaFisicaWebNovo)">
          <a>
            <i class="fa fa-edit"></i>
            <span class="nav-label">Alterar Cadastro</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'pessoa-fisica.assinatura' }" 
                     v-if="(usuario.tipoUsuario === tipoUsuario.PessoaFisica && habilitarAssinaturaEletronica)">
          <a>
            <i class="fa fa-folder-open-o"></i>
            <span class="nav-label">Assinatura Eletrônica</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'pessoa-fisica.irpf' }" v-if="(usuario.tipoUsuario === tipoUsuario.PessoaFisica)">
          <a>
            <i class="fa fa-money"></i>
            <span class="nav-label">Declaração de Rendimentos</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'solicitacao-reembolso-pf-atividade' }" v-if="prestacaoContasPessoaFisica">
          <a>
            <i class="fa fa-plane"></i>
            <span class="nav-label">Diária {{ configuracao.utilizarSolicitacaoAdiantamentoPassagemWeb ? ' - Passagem' : '' }} {{ configuracao.utilizarSolicitacaoAdiantamentoWeb ? ' - Adiantamento' : '' }} - Prestação de contas</span>
          </a>
        </router-link>

        <!--Acesso especial-->
        <li :class="{'active': $route.name.startsWith('acesso-especial-relatorio.')}"
            v-if="relatoriosAcessoEspecial">
          <a href="#">
            <i class="fa fa-line-chart"></i>
            <span class="nav-label">Relatórios </span><span class="fa arrow"></span>
          </a>
          <ul class="nav nav-second-level collapse"
              :class="{'in': $route.name.startsWith('acesso-especial-relatorio.')}">

            <router-link tag="li" :to="{ name: 'acesso-especial-relatorio.controle-item' }" v-if="usuario.acessoEspecialPermissoes.relControleItem">
              <a>Controle Item</a>
            </router-link>

            <router-link tag="li" :to="{ name: 'acesso-especial-relatorio.lancamentos' }" v-if="usuario.acessoEspecialPermissoes.relLancamentoFinanceiro">
              <a>Lançamentos Financeiros</a>
            </router-link>

            <router-link tag="li" :to="{ name: 'acesso-especial-relatorio.rubricas' }" v-if="usuario.acessoEspecialPermissoes.relRubrica">
              <a>Rubricas</a>
            </router-link>

          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/Menu.vue